import TextField from '@pages/Admin/CourseSettings/components/TextField/TextField'
import { FC, useEffect, useState } from 'react'
import cn from './index.module.css'
import { checkIsEmail } from '../../utils/validation'
import { checkEmailExist, ICheckEmailResponse } from '../../utils/api'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

interface IEmailField {
  courseId: number
  value: string
  onChange: (value: string) => void
  existedData: ICheckEmailResponse
  onExistedChange: (value: ICheckEmailResponse) => void
  isInvalid: boolean
}

function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

const EmailField: FC<IEmailField> = ({
  courseId,
  value,
  onChange,
  isInvalid,
  existedData,
  onExistedChange,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const debouncedValue = useDebounce(value, 500)

  useEffect(() => {
    const checkEmail = async () => {
      if (checkIsEmail(debouncedValue)) {
        const existed = await checkEmailExist(debouncedValue, courseId)
        onExistedChange(existed)
      }
      setIsLoading(false)
    }
    checkEmail()
  }, [debouncedValue])

  useEffect(() => {
    if (value && !isInvalid) setIsLoading(true)
  }, [value])

  return (
    <div className={cn.wrapper}>
      <div className={cn.row}>
        <TextField
          className={cn.inputField}
          placeholder="Email"
          value={value}
          type="email"
          onChange={onChange}
          isInvalid={isInvalid}
        />
        {isLoading && (
          <Spin
            indicator={
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          />
        )}
      </div>
      {value && !isInvalid && !existedData.hasCourse && (
        <div className={cn.description}>
          {!!existedData?.user
            ? 'Курс добавится в существующий личный кабинет, привязанный к этой почте'
            : 'Логин и пароль для личного кабинета будут отправлены на указанную почту'}
        </div>
      )}
    </div>
  )
}

export default EmailField
